import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./EnquiryHome.css";

export default function EnquiryHome() {
  const nav = useNavigate();

  // Pressing Escape sends user back to dashboard
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape" || e.key === "Esc") {
        e.preventDefault();
        nav("/dashboard");        // ← change this path if your dashboard route differs
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [nav]);

  return (
    <div className="enquiryHome">
      <h1>Enquiry</h1>
      <div className="grid">
        <button className="btn" onClick={() => nav("/enquiry/nric")}>Search by NRIC</button>
        <button className="btn" onClick={() => nav("/enquiry/item")}>Search by Item Description</button>
        <button className="btn" onClick={() => nav("/enquiry/name")}>Search by Name</button>
        <button className="btn" onClick={() => nav("/enquiry/ticket")}>Search by Ticket No.</button>
          <button className="btn" onClick={() => nav("/enquiry/redeemed")}>Search by Redeemed (MMYY)</button>
          <button className="btn" onClick={() => nav("/enquiry/redeem-by")}>
          Search by Redeem By (NRIC)
        </button>
      </div>
    </div>
  );
}
